'use client'
import {useState } from 'react'
import { PrismicRichText } from '@prismicio/react'

interface TopicTileProps {
    open: any | null;
    data: any | null
}

const TopicTile: React.FC<TopicTileProps> = ({ open, data }) => {
  // console.log(props)

  const [openState, setOpenState] = useState(open === 0 ? true : false)

  return (
    <div className={`text-[14px] leading-[22px] ${data.background} w-full mx-[0] my-[20px] rounded-[16px] relative topic-' + data.colour.toLowerCase().replace(" ","")`}>
      <div className={'cursor-pointer text-[white] font-semibold px-[24px] py-[12px] rounded-tl-[16px] rounded-tr-[16px] relative  open-'+openState} onClick={()=> setOpenState(!openState)}>
        {data.heading} <span className="block absolute right-[10px] top-[10px] text-[22px]">{openState== true ? '–' :'+'}</span>
      </div>
      {openState===true ?
      <>
      <div className="p-6 prose prose-p:text-[14px] prose-li:text-[14px] bg-white prose-ul:m-0 prose-li:ml-4 prose-ul:p-0 prose-li:marker:text-black prose-a:text-blue">
        <PrismicRichText field={data.description1}/>
      </div>
      {data.contact_email?.url ? 
      <div className="border-t-[1px] border-t-deepjadeborder px-[24px] py-[16px] bg-white rounded-b-[16px]">
        <p>For more information contact<br/>
        <a href={data.contact_email.url}>{data.contact_email.url?.replace("mailto:","")}</a></p>
      </div>
      :<></>}
      </>:<></>}
    </div>
  )

}

export default TopicTile;

